$(function() {

  $('[data-bgimage]').each(function(a,b) {
        var bgImage = $(b).data('bgimage');
        if(bgImage && bgImage.length>0) {
          $(b).parents('section').css('background','url("'+bgImage+'") center top / cover no-repeat');// fixed');
        }
    }).removeAttr('data-bgimage');

    $('[data-sectionclass]').each(function(a,b) { // class toevoegen aan "hoofdsection"
      var sectionclass = $(b).data('sectionclass');
          $(b).parents('section').first().addClass(sectionclass);
    }).removeAttr('data-sectionclass');

    $('[data-firstcontainerclass]').each(function(a,b) { // class toevoegen aan "hoofdsection" en dan de container
      var sectionclass = $(b).data('firstcontainerclass');
          $(b).parents('section').first().find('.container').first().addClass(sectionclass);
    }).removeAttr('data-firstcontainerclass');

    $('[data-sectionimage]').each(function(a,b) {
      var sectionimage = $(b).data('sectionimage');
          $(b).parents('section').css('background',"url('" + sectionimage + "')");
    }).removeAttr('data-sectionimage');


    $('[data-containerclass]').each(function(a,b) { // class toevoegen aan parent container
      var containerClass = $(b).data('containerclass');
          $(b).parents('.row').first().addClass(containerClass);

    }).removeAttr('data-containerclass');

    $('[data-classname]').each(function(a,b) { // class toevoegen aan parent
      var containerClass = $(b).data('classname');
        $(b).parent().addClass(containerClass);
    }).removeAttr('data-classname');

    $('[data-rowclass]').each(function(a,b) { // class toevoegen aan parent row
      var rowclass = $(b).data('rowclass');
        $(b).parents('.row').first().addClass(rowclass);
    }).removeAttr('data-rowclass');


  var paralaxs = $('div.row[data-parallax="true"]');
  if(paralaxs.length>0) {

    paralaxs.each(function(a,b) {

      var target = $(b).parents('section').first();
      if($(target).length>0) {
        var image = $(target).css('background-image').replace('url("','').replace('")','').replace("url(",'').replace(')','');
            image = image.replace('/photos/','/media/parallax/');
        if(image!='none') {
          $(target).css('background-image','').css('z-index',2);
          $(target).parallax({imageSrc:image,zIndex:0});
        }
      }
    });
}

$('[data-widgettype="partners"]').parents('section').first().addClass('partners bg-white');

$('[data-type="component-googlemap"]').parents('section').first().addClass('gmap');

$('[data-widgettype="headlines"]').parents('section').first().addClass('bg-white');

});



// WEBPACK FOOTER //
// ./resources/assets/js/blockcms.js